import { isInvalidSchema } from "@aura-design/system/form"
import * as regex from "@airplan/utils/regex"

export const contactFormSchema = ({
  fullName,
  email,
  message,
  airport,
  accept,
}: Record<string, any>) => {
  let schema: Record<string, boolean> = {}

  if (fullName.value === "") {
    fullName.dialog("Escribe tu nombre completo.")
    schema.fullName = false
  } else {
    schema.fullName = true
    fullName.dialog(null)
  }

  if (email.value === "") {
    email.dialog("Escribe tu correo electrónico.")
    schema.email = false
  } else if (!regex.email.test(email.value)) {
    email.dialog("No es un correo electrónico válido")
    schema.email = false
  } else {
    schema.email = true
    email.dialog(null)
  }

  if (airport.value === "") {
    airport.dialog("Elige un aeropuerto")
    schema.airport = false
  } else {
    schema.airport = true
    airport.dialog(null)
  }

  if (message.value === "") {
    message.dialog("Escribe tu mensaje.")
    schema.message = false
  } else {
    schema.message = true
    message.dialog(null)
  }

  if (!Boolean(accept.value)) {
    accept.dialog("Este campo es obligatorio.")
    schema.accept = false
  } else {
    schema.accept = true
    accept.dialog(null)
  }

  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}

export const claimFormSchema = ({
  description,
  date,
  firstName,
  lastName,
  email,
  airport,
  accept,
}: Record<string, any>) => {
  let schema: Record<string, boolean> = {}
  if (description.value === "") {
    description.dialog("Este campo es obligatorio.")
    schema.description = false
  } else {
    schema.description = true
    description.dialog(null)
  }
  if (date.value === "") {
    date.dialog("Este campo es obligatorio.")
    schema.date = false
  } else {
    schema.date = true
    date.dialog(null)
  }
  if (firstName.value === "") {
    firstName.dialog("Este campo es obligatorio.")
    schema.firstName = false
  } else {
    schema.firstName = true
    firstName.dialog(null)
  }
  if (lastName.value === "") {
    lastName.dialog("Este campo es obligatorio.")
    schema.lastName = false
  } else {
    schema.lastName = true
    lastName.dialog(null)
  }
  if (email.value === "") {
    email.dialog("Escribe tu correo electrónico.")
    schema.email = false
  } else if (!regex.email.test(email.value)) {
    email.dialog("No es un correo electrónico válido")
    schema.email = false
  } else {
    schema.email = true
    email.dialog(null)
  }
  if (airport.value === "") {
    airport.dialog("Este campo es obligatorio.")
    schema.airport = false
  } else {
    schema.airport = true
    airport.dialog(null)
  }
  if (!Boolean(accept.value)) {
    accept.dialog("Este campo es obligatorio.")
    schema.accept = false
  } else {
    schema.accept = true
    accept.dialog(null)
  }
  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}

export const hazardReportForm = ({
  airport,
  date,
  time,
  weather,
  location,
  message,
  visibility,
  surface,
  reason,
  eventFrecuency,
  accept,
}: Record<string, any>) => {
  let schema: Record<string, boolean> = {}
  if (airport.value === "") {
    airport.dialog("Este campo es obligatorio.")
    schema.airport = false
  } else {
    schema.airport = true
    airport.dialog(null)
  }
  if (date.value === "") {
    date.dialog("Este campo es obligatorio.")
    schema.date = false
  } else {
    schema.date = true
    date.dialog(null)
  }
  if (time.value === "") {
    time.dialog("Este campo es obligatorio.")
    schema.time = false
  } else {
    schema.time = true
    time.dialog(null)
  }
  if (weather.value === "") {
    weather.dialog("Este campo es obligatorio.")
    schema.weather = false
  } else {
    schema.weather = true
    weather.dialog(null)
  }
  if (location.value === "") {
    location.dialog("Este campo es obligatorio.")
    schema.location = false
  } else {
    schema.location = true
    location.dialog(null)
  }
  if (message.value === "") {
    message.dialog("Este campo es obligatorio.")
    schema.message = false
  } else {
    schema.message = true
    message.dialog(null)
  }
  if (visibility.value === "") {
    visibility.dialog("Este campo es obligatorio.")
    schema.visibility = false
  } else {
    schema.visibility = true
    visibility.dialog(null)
  }
  if (surface.value === "") {
    surface.dialog("Este campo es obligatorio.")
    schema.surface = false
  } else {
    schema.surface = true
    surface.dialog(null)
  }
  if (reason.value === "") {
    reason.dialog("Este campo es obligatorio.")
    schema.reason = false
  } else {
    schema.reason = true
    reason.dialog(null)
  }
  if (eventFrecuency.value === "") {
    eventFrecuency.dialog("Este campo es obligatorio.")
    schema.eventFrecuency = false
  } else {
    schema.eventFrecuency = true
    eventFrecuency.dialog(null)
  }
  if (!Boolean(accept.value)) {
    accept.dialog("Este campo es obligatorio.")
    schema.accept = false
  } else {
    schema.accept = true
    accept.dialog(null)
  }
  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}

export const lostObjectFormSchema = ({
  description_object,
  lastSeenTime,
  ownershipProof,
  firstName,
  email,
  airport,
  accept,
}: Record<string, any>) => {
  let schema: Record<string, boolean> = {}
  if (description_object.value === "") {
    description_object.dialog("Este campo es obligatorio.")
    schema.description_object = false
  } else {
    schema.description_object = true
    description_object.dialog(null)
  }
  if (lastSeenTime.value === "") {
    lastSeenTime.dialog("Este campo es obligatorio.")
    schema.lastSeenTime = false
  } else {
    schema.lastSeenTime = true
    lastSeenTime.dialog(null)
  }
  if (ownershipProof.value === "") {
    ownershipProof.dialog("Este campo es obligatorio.")
    schema.ownershipProof = false
  } else {
    schema.ownershipProof = true
    ownershipProof.dialog(null)
  }
  if (firstName.value === "") {
    firstName.dialog("Este campo es obligatorio.")
    schema.firstName = false
  } else {
    schema.firstName = true
    firstName.dialog(null)
  }
  if (email.value === "") {
    email.dialog("Escribe tu correo electrónico.")
    schema.email = false
  } else if (!regex.email.test(email.value)) {
    email.dialog("No es un correo electrónico válido")
    schema.email = false
  } else {
    schema.email = true
    email.dialog(null)
  }
  if (airport.value === "") {
    airport.dialog("Este campo es obligatorio.")
    schema.airport = false
  } else {
    schema.airport = true
    airport.dialog(null)
  }
  if (!Boolean(accept.value)) {
    accept.dialog("Este campo es obligatorio.")
    schema.accept = false
  } else {
    schema.accept = true
    accept.dialog(null)
  }
  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}

export const signInSchema = ({ password, email }) => {
  let schema: Record<string, boolean> = {}

  if (email.value === "") {
    email.dialog("Debes escribir tu correo electrónico")
    schema.email = false
  } else if (!regex.email.test(email.value)) {
    email.dialog("No es un correo electrónico válido")
    schema.email = false
  } else {
    schema.email = true
    email.dialog(null)
  }

  if (password.value === "") {
    password.dialog("Debes escribir una contraseña")
    schema.password = false
  } else {
    schema.password = true
    password.dialog(null)
  }

  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}

export const profileSchema = ({
  gender,
  maritalStatus,
  stateOfResidence,
  cityOrMunicipalityOfResidence,
  residentialAddress,
  neighborhoodOrSector,
  socioeconomicStratum,
  highestLevelOfEducationCompleted,
  lastAcademicDegreeObtained,
  emergencyContactName,
  emergencyContactRelationship,
  emergencyContactPhone,
}: Record<string, any>) => {
  let schema: Record<string, boolean> = {}
  if (gender.value === "") {
    gender.dialog("Este campo es obligatorio.")
    schema.gender = false
  } else {
    schema.gender = true
    gender.dialog(null)
  }

  if (maritalStatus.value === "") {
    maritalStatus.dialog("Este campo es obligatorio.")
    schema.maritalStatus = false
  } else {
    schema.maritalStatus = true
    maritalStatus.dialog(null)
  }

  if (stateOfResidence.value === "") {
    stateOfResidence.dialog("Este campo es obligatorio.")
    schema.stateOfResidence = false
  } else {
    schema.departmenstateOfResidencetOfResidence = true
    stateOfResidence.dialog(null)
  }
  
  if (cityOrMunicipalityOfResidence.value === "") {
    cityOrMunicipalityOfResidence.dialog("Este campo es obligatorio.")
    schema.cityOrMunicipalityOfResidence = false
  } else {
    schema.cityOrMunicipalityOfResidence = true
    cityOrMunicipalityOfResidence.dialog(null)
  }

  if (residentialAddress.value === "") {
    residentialAddress.dialog("Este campo es obligatorio.")
    schema.residentialAddress = false
  } else {
    schema.residentialAddress = true
    residentialAddress.dialog(null)
  }

  if (neighborhoodOrSector.value === "") {
    neighborhoodOrSector.dialog("Este campo es obligatorio.")
    schema.neighborhoodOrSector = false
  } else {
    schema.neighborhoodOrSector = true
    neighborhoodOrSector.dialog(null)
  }

  if (socioeconomicStratum.value === "") {
    socioeconomicStratum.dialog("Este campo es obligatorio.")
    schema.socioeconomicStratum = false
  } else {
    schema.socioeconomicStratum = true
    socioeconomicStratum.dialog(null)
  }

  if (highestLevelOfEducationCompleted.value === "") {
    highestLevelOfEducationCompleted.dialog("Este campo es obligatorio.")
    schema.highestLevelOfEducationCompleted = false
  } else {
    schema.highestLevelOfEducationCompleted = true
    highestLevelOfEducationCompleted.dialog(null)
  }

  if (lastAcademicDegreeObtained.value === "") {
    lastAcademicDegreeObtained.dialog("Este campo es obligatorio.")
    schema.lastAcademicDegreeObtained = false
  } else {
    schema.lastAcademicDegreeObtained = true
    lastAcademicDegreeObtained.dialog(null)
  }

  if (emergencyContactName.value === "") {
    emergencyContactName.dialog("Este campo es obligatorio.")
    schema.emergencyContactName = false
  } else {
    schema.emergencyContactName = true
    emergencyContactName.dialog(null)
  }

  if (emergencyContactRelationship.value === "") {
    emergencyContactRelationship.dialog("Este campo es obligatorio.")
    schema.emergencyContactRelationship = false
  } else {
    schema.emergencyContactRelationship = true
    emergencyContactRelationship.dialog(null)
  }

  if (emergencyContactPhone.value === "") {
    emergencyContactPhone.dialog("Este campo es obligatorio.")
    schema.emergencyContactPhone = false
  } else {
    schema.emergencyContactPhone = true
    emergencyContactPhone.dialog(null)
  }

  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}

export const newUserSchema = ({
  email
}: Record<string, any>) => {
  let schema: Record<string, boolean> = {}
  if (email.value === "") {
    email.dialog("Este campo es obligatorio.")
    schema.gender = false
  } else if (!regex.email.test(email.value)) {
    email.dialog("No es un correo electrónico válido")
    schema.email = false
  } else {
    schema.gender = true
    email.dialog(null)
  }

  if (isInvalidSchema(schema)) {
    return false
  } else {
    return true
  }
}
